import React from 'react';
import {
  OwcButton,
  OwcExpandable,
  OwcInput,
  OwcTypography,
  OwcIcon,
  OwcSelectDropdown,
  OwcListItem,
  OwcAssistiveText,
} from '@one/react';
import { configData } from '../../../config.js';
import { fetchSigned, checkForCompletion } from "../../../shared/Utilities.js";

const BASE_URL = configData.DEVICE_INVESTIGATION_URL
const REF_SYSTEM_TYPE_BLANK_VALUE = "Select Ref System Type";

class DeviceInvestigation extends React.Component {

  constructor(props) {
    super(props);

    this.cancelRequested = React.createRef();
    this.cancelRequested.current = false;

    this.state = {
      reportResults: null,
      userMessage: null,
      isInvestigating: false,
      dataUseId: '',
      materialNumber: '',
      referenceSystemType: '',
      serialNo: '',
      label: {},
      systemTypeList:[],
      dataUseList:[]
    };
  }

  static getDataProductName() {
    return "Device Investigation Report";
  }

  /* =========================
     Helpers
     ========================= */

  isFormValid = () => {
    const { materialNumber, referenceSystemType, serialNo } = this.state;
    const trimmedMaterialNumber = materialNumber===undefined?"":materialNumber.trim();
    const trimmedSerialNo = serialNo===undefined?"":serialNo.trim();
    return (
      (referenceSystemType !== "" || trimmedMaterialNumber !== '') &&
      trimmedSerialNo !== ''
    );
  };

  mapSummaryToEntitlements = (summaryArray = []) => {
    return summaryArray.map(item => ({
      label: item.text,
      allowed: item.status === 'passed',
      description: item.description,
    }));
  };

 formatDate = (iso) => {
  if (!iso) return 'na';

  return new Date(iso).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',   // Jan, Feb, Mar
    year: 'numeric',
  });
};

  /* =========================
     Data Fetching Logic
     ========================= */


  componentDidMount() {
    fetchSigned(
      configData.REFDATA_API_URL + "?includeInactive=false"
    )
    .then(res => res.json())
    .then(result => {
      const systemTypeList = result.filter(
        item => item.type === "Reference System Type"
      );
      this.setState({ systemTypeList });
    })
    .catch(error => {
      this.setState({
        userMessage: { message: error.toString(), type: "error" }
      });
    });

    
    const searchData = {
      searchBy: "Name",
      searchTerm: "",
      sortBy: "Use Case Id",
      limit: 1000000,
      offset: 0,
    };
    fetchSigned(configData.USECASE_API_URL + "search/", {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(searchData)
    })
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            dataUseList: result.searchResults
          });
        },
        (errorMsg) => {
          this.setState({
            userMessage: { message: errorMsg, type: "error" }
          });
        }
      );

    this.loadDataProductLabel();
  }

  loadDataProductLabel() {
    this.setState({ label: {} });
    const labelUrl = BASE_URL + "label/";
    fetchSigned(labelUrl)
      .then(async response => {
        let responseDict = {};

        if (response !== undefined) {
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            responseDict = await response.json();
          } else {
            console.log(response)
          }
        }
        this.setState({ label: responseDict });
      })
      .catch(error => {
        this.setState({ responseText: error.toString() });
        console.error('There was an error!', error);
      });
  }

  handleSubmitClick = () => {
    if (!this.isFormValid()) return;

    this.cancelRequested.current = false;

    this.setState({
      userMessage: { message: "Investigating device...", type: "warning" },
      reportResults: null,
      isInvestigating:true
    });

    const { dataUseId, serialNo, referenceSystemType, materialNumber } = this.state;

    const params = new URLSearchParams({
      dataUseId,
      serialNo,
      referenceSystemType,
      materialNumber
    }).toString().replace(/\+/g, '%20');

    const urlToFetch = `${BASE_URL}?${params.toString()}`;

    fetchSigned(urlToFetch)
      .then(async response => {
        if (!response || !response.ok) {
          this.setState({
            userMessage: { message: "Error requesting device investigation", type: "error", isInvestigating:false },
          });
          return;
        }

        const responseDict = await response.json();
        if (!this.cancelRequested.current) {
          this.handleDataProductWait(responseDict);
        }
      })
      .catch(error => {
        this.setState({
          userMessage: { message: error.toString(), type: "error", isInvestigating:false },
        });
      });
  };

  async handleDataProductWait(responseDict) {
    const requestResult = await checkForCompletion(
      `${BASE_URL}status/${responseDict}`,
      this.cancelRequested
    );

    if (requestResult.status === "SUCCEEDED") {
      this.getResults(requestResult.resultUrl);
    } else {
      this.setState({
        userMessage: { message: requestResult.responseText, type: "error", isInvestigating:false },
      });
    }
  }

  getResults(resultsURL) {
    fetch(resultsURL)
      .then(async response => {
        if (!response.ok) {
          this.setState({
            userMessage: { message: "Failed to fetch results", type: "error", isInvestigating:false },
            isInvestigating:false
          });
          return;
        }

        const reportResults = await response.json();
        console.log(reportResults)
        this.setState({
          reportResults,
          userMessage: null,
          isInvestigating: false
        });
      })
      .catch(error => {
        this.setState({
          userMessage: { message: error.toString(), type: "error", isInvestigating:false },
        });
      });
  }

  collapseConnectedSerialNos(connectedSerialNumbersList) {
    let collapsedDict = {};
    connectedSerialNumbersList.forEach(entry => {
      const entryData = entry.connectedSerialNumber;
      if (entryData.source in collapsedDict) {
        collapsedDict[entryData.source].valueList.push(entryData.value);
      } else {
        collapsedDict[entryData.source] = {source: entryData.source,
          valueList: [entryData.value]
        }
      }
    });
    return Object.values(collapsedDict);
  }

  /* =========================
     UI
     ========================= */

  renderDatauseAndDeviceSelection() {
    const { dataUseId,systemTypeList, materialNumber } = this.state;
    const formattedSystemTypeList = systemTypeList.map(item =>
      item.description +
      (item.isActive === false ? " (Deprecated)" : "")
    );

    let description = "";
    if (Object.keys(this.state.label).length > 0) {
      const dataProductAttributes = this.state.label[configData.LABEL_KEYS.DATA_PRODUCT_ATTRIBUTES_KEY][configData.LABEL_KEYS.CHILDREN_KEY];
      if (dataProductAttributes !== undefined) {
        if (dataProductAttributes[configData.LABEL_KEYS.DESCRIPTION_KEY] !== undefined) {
          description = dataProductAttributes[configData.LABEL_KEYS.DESCRIPTION_KEY][configData.LABEL_KEYS.VALUE_KEY];
        }
      }
    }


    return (
      <div style={{ padding: '0rem 3rem', maxWidth: '100%'}}>
        <div style={{ display: 'flex', width: '100%'}}>
          <div>
            <div style={{ display: 'flex', alignItems: 'top', paddingBottom: '20px', minWidth: '350px' }}>
              <OwcTypography style={{ paddingRight: '20px', paddingTop: '0.6em' }}>
                Data Use Id
              </OwcTypography>

              <div>
                <OwcSelectDropdown
                  searchable
                  style={{width: "30em"}}
                  size="small"
                  value={dataUseId}
                  onValueChange={(ev) => {
                      this.setState({ dataUseId: ev.detail[0]===undefined?"":ev.detail[0]})}
                    }
                >
                  {
                    this.state.dataUseList.map(dataUse=>(
                      <OwcListItem 
                        key={"dataUseListItem" + dataUse.useCaseId}
                        value={dataUse.useCaseId}
                        searchKey={`${dataUse.useCaseId}|${dataUse.name}`}
                      >{dataUse.useCaseId} - {dataUse.name}</OwcListItem>
                    ))
                  }
                

                </OwcSelectDropdown>
                <OwcAssistiveText slot="assistive-text" trigger="blur"> 
                  Type to search by data use id or name
              </OwcAssistiveText>
              </div>
            </div>

          </div>

          <div
            style={{
              width: '50%',
              minHeight: '2em',
              padding: '1rem',
              backgroundColor: '#FFFFE0',
              marginLeft: '2rem',
            }}
          >
            {description}
          </div>
        </div>
        <OwcTypography>
          <b>Device To Investigate</b>
        </OwcTypography>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
          <div style={{ display: 'flex', flexDirection: 'column'}}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <OwcTypography style={{ paddingRight: '20px' }}>
              Ref System Type
            </OwcTypography>

            <select
              style={(this.state.referenceSystemType === null || 
                      this.state.referenceSystemType === '')?
                        { width: "250px", color:"grey" }:
                        { width: "250px"}}
              value={this.state.referenceSystemType}
              onChange={(ev) =>
                this.setState({ referenceSystemType: ev.target.value })
              }
            >
              <option style={{color:"grey"}} value="">{REF_SYSTEM_TYPE_BLANK_VALUE}</option>
              {formattedSystemTypeList.map((item, index) => (
                <option key={index} value={item} style={{color:"black"}}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <OwcTypography style={{ paddingRight: '20px' }}>
              Or Material Number
            </OwcTypography>
            <OwcInput
              placeholder="Enter Material Number"
              value={materialNumber}
              type="number"
              onValueChange={(ev) =>
                this.setState({ materialNumber: ev.detail.replace(/\D/g,'') })
              }
            />
          </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '2rem' }}>
            <OwcTypography style={{ paddingRight: '20px' }}>
              Serial Number
            </OwcTypography>

            <OwcInput
              placeholder="Serial Number"
              value={this.state.serialNo}
              onValueChange={(ev) =>
                this.setState({ serialNo: ev.detail.trim() })
              }
            />
          </div>

          <div style={{ width: '20%', display: 'flex', justifyContent: 'flex-end', paddingTop: '0.6em' }}>
            <OwcButton
              disabled={!this.isFormValid() || this.state.isInvestigating}
              onClick={this.handleSubmitClick}
            > 
              Investigate Device              
            </OwcButton>
          </div>
        </div>
        <div style={{display:'flex',justifyContent:'flex-end'}}>
          <OwcTypography>
        {this.state.isInvestigating &&'Investigating Device...'}
        </OwcTypography>
        </div>
      </div>
    );
  }

  renderDeviceEntitlementResults() {
    const { reportResults } = this.state;
    if (!reportResults) return null;

    const summary =
      reportResults.deviceInvestigationReport?.data?.summary || {};

    const dataUseList = this.mapSummaryToEntitlements(summary.dataUse);
    const deviceList = this.mapSummaryToEntitlements(summary.device);
    const applicableDeviceList = this.mapSummaryToEntitlements(summary.applicableDevice);

    const dataUseDetails =
      reportResults.deviceInvestigationReport?.data?.details?.dataUse;
    const deviceDetails = reportResults.deviceInvestigationReport?.data?.details?.device;
    const device = reportResults.deviceInvestigationReport?.data?.details?.applicableDevice;
    const connectedSerialNumbers = deviceDetails?.connectedSerialNumbers?
        this.collapseConnectedSerialNos(deviceDetails.connectedSerialNumbers)
      :
        [];

    return (

      <div style={{ padding: '0rem 3rem', maxWidth: '100rem'}}>
        {/* Data Use */}
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <div>
          <OwcTypography variant="title6">Data Use</OwcTypography>
          <div style={{borderBottom:'2px solid gray',marginBottom:'1rem'}}>
          <OwcTypography style={{ fontSize: '12px',color:'gray' }}>
            Data Use Id {this.state.dataUseId}
          </OwcTypography>
          </div>

          {dataUseList.map((item, index) => (
            <ResultRow key={index} item={item} />
          ))}
        </div>

        {/* Device */}
        <div>
          <OwcTypography variant="title6">Device</OwcTypography>
          <div style={{borderBottom:'2px solid gray',marginBottom:'1rem'}}>
          <OwcTypography style={{ fontSize: '12px', color: 'gray' }}>
            {this.state.serialNo}
            { ` (${deviceDetails?.referenceSystemType===undefined?this.state.referenceSystemType:deviceDetails?.referenceSystemType})`}
          </OwcTypography>
          </div>
          {deviceList.map((item, index) => (
            <ResultRow key={index} item={item} />
          ))}
        </div>

        {/* Applicable Device */}
        <div>
          <OwcTypography variant="title6">Applicable Device</OwcTypography>
          <div style={{borderBottom:'2px solid gray',marginBottom:'1rem'}}>
          <OwcTypography style={{ fontSize: '12px', color: 'gray' }}>
          {this.state.serialNo}
          { ` (${deviceDetails?.referenceSystemType===undefined?this.state.referenceSystemType:deviceDetails?.referenceSystemType}) in data use id ${this.state.dataUseId}`}
        </OwcTypography>
        </div>
          {applicableDeviceList.map((item, index) => (
            <ResultRow key={index} item={item} />
          ))}
        </div>
        </div>
        <div style={{paddingTop:'2rem',display:'flex',justifyContent:'space-between',minWidth:'300px', gap:'1rem'}}>
          <div style={{minWidth:'300px'}}>
            <div style={{borderBottom:'2px solid gray',marginBottom:'1rem'}}>
            <OwcTypography variant='title6'>Data Use Details</OwcTypography>
            </div>
            <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}> 
              <OwcTypography>Name :</OwcTypography>
              <div><OwcTypography>{dataUseDetails?.name}</OwcTypography></div>
            </div>
            
            </div>
          <div style={{minWidth:'300px'}}> 
            <div style={{borderBottom:'2px solid gray',marginBottom:'1rem'}}>
            <OwcTypography variant='title6'>Device Details</OwcTypography>
            </div>
            <div>
              <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography>Ref System Type :</OwcTypography>
                <div><OwcTypography>{deviceDetails?.referenceSystemType}</OwcTypography></div>
              </div>
              <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography>Material No :</OwcTypography>
                <div><OwcTypography>{deviceDetails?.materialNumber}</OwcTypography></div>
              </div>
              <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography>Material Name :</OwcTypography>
                <div><OwcTypography>{deviceDetails?.materialName}</OwcTypography></div>
              </div>
              <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography>Serial No :</OwcTypography>
                <div><OwcTypography>{deviceDetails?.serialNo}</OwcTypography></div>
              </div>
              <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography>Lab Id :</OwcTypography>
                <div><OwcTypography>{deviceDetails?.labId}</OwcTypography></div>
              </div>
              <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography>Instrument Location :</OwcTypography>
                <div><OwcTypography>{deviceDetails?.instrumentLocation}</OwcTypography></div>
              </div>
              <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography>Last Upload Date :</OwcTypography>
                <div><OwcTypography>{this.formatDate(deviceDetails?.lastUploadDate)}</OwcTypography></div>
              </div>
              <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography>Current Country :</OwcTypography>
                <div><OwcTypography>{deviceDetails?.country}</OwcTypography></div>
              </div>
               <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography><b>Data Source</b></OwcTypography>
                <div><OwcTypography><b>Serial Numbers</b></OwcTypography></div>
              </div>
              {connectedSerialNumbers.map((item,index)=> (
                <div key={index} style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
                <OwcTypography>{item.source} :</OwcTypography>
                <OwcTypography>{item.valueList.join(", ")}</OwcTypography>
              </div>
              ))}
            </div>
          </div>
          <div style={{minWidth:'300px',}}> 
            <div style={{borderBottom:'2px solid gray',marginBottom:'1rem'}}>
            <OwcTypography variant='title6'>Applicable Periods</OwcTypography>
            </div>
          <div >
          <div style={{display:'flex',justifyContent:'space-between', gap: '1rem'}}>
            <OwcTypography><b>From</b></OwcTypography>
            <OwcTypography><b>To</b></OwcTypography>
            
          </div>
          {device?.applicablePeriods?.map((item, index) => (
            <div
              key={index}
              style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem'}}
            >
              <OwcTypography>{this.formatDate(item?.start)}</OwcTypography>
              <OwcTypography>{this.formatDate(item?.end)}</OwcTypography>
            </div>
          ))}
          </div>
          </div>
          
        </div>
      </div>
    );
  }

  render() {
    const { reportResults } = this.state;

    return (
      <div style={{ marginLeft: "2em", marginRight: "2em" }}>
        <OwcExpandable style={{ marginTop: "0.5em", borderTop: "2px solid gray" }} roundedControl expanded variant="transparent">
          <span slot="title">
            <OwcTypography variant="title6">
              Data Use & Device Selection
            </OwcTypography>
          </span>

          <span slot="content">
            {this.renderDatauseAndDeviceSelection()}
          </span>
        </OwcExpandable>

        {this.state.userMessage?.type === "error" ? (
  <div
    style={{
      marginTop: "0.5em",
      padding: "1rem 3rem",
      color: "red",
      borderTop: "1px solid red",
    }}
  >
    <OwcTypography style={{ color: "red" }}>
      {this.state.userMessage.message}
    </OwcTypography>
  </div>
) : (
  reportResults && (
    <OwcExpandable
      expanded
      style={{ marginTop: "0.5em", borderTop: "2px solid gray" }}
      roundedControl
      variant="transparent"
    >
      <span slot="title">
        <OwcTypography variant="title6">
          Device Entitlements Results
        </OwcTypography>
      </span>

      <span slot="content">
        {this.renderDeviceEntitlementResults()}
      </span>
    </OwcExpandable>
  )
)}
      </div>
    );
  }
}

/* =========================
   Small Reusable Row
   ========================= */

const ResultRow = ({ item }) => (
  <div
    style={{
      display: 'flex',
      minWidth: '300px',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid gray',
      padding: '0.25rem 0',
    }}
    title={item.description}
  >
    <div>{item.label}</div>
    <OwcIcon
      name={item.allowed ? 'circle_confirm' : 'circle_info'}
      style={{ color: item.allowed ? 'green' : 'red' }}
    />
  </div>
);

export default DeviceInvestigation;
